import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { get, isArray, cloneDeep } from 'lodash';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
var emptyTransformer = {
  transformer: {
    definition: '$',
    type: 'jsonata',
    contentTypes: {}
  },
  properties: {}
};
var VIEW_MODES = {
  CREATE: 'CREATE',
  EDIT: 'EDIT'
};
export default {
  name: 'ViewConnectorsConsumersTransformersEdit',
  components: {
    codemirror: codemirror
  },
  data: function data() {
    return {
      showMetaSkeleton: true,
      tabItem: 'tab-metadata',
      selectedAccount: {},
      accounts: [],
      //
      transformerTypes: ['jsonata', 'javascript'],
      transformerModel: cloneDeep(emptyTransformer),
      inputOutputTypes: ['application/json', 'text/plain', 'generic'],
      transformTestInput: '',
      transformTestOutput: '',
      // code-mirror
      cmOptions: {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: this.cmLineNumbers,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled', 'isMobile'])), {}, {
    canSave: function canSave() {
      var hasOutputType = get(this.transformerModel, 'transformer.contentTypes.output', null);
      var hasName = get(this.transformerModel, 'name', null);
      var hasAccount = get(this.selectedAccount, 'id', null);
      return hasOutputType && hasName && hasAccount;
    },
    viewMode: function viewMode() {
      return this.$route.params.id ? VIEW_MODES.EDIT : VIEW_MODES.CREATE;
    },
    isCreate: function isCreate() {
      return this.viewMode === VIEW_MODES.CREATE;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    isWide: function isWide() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    canRunTransformerTest: function canRunTransformerTest() {
      return this.selectedAccount.id && this.transformTestInput && this.transformerModel.transformer.contentTypes.output;
    },
    tooltipTransformerTest: function tooltipTransformerTest() {
      if (!this.selectedAccount.id) {
        return this.$i18n_t('Connectors.Transformer.testButtonTooltip.accountRequired');
      } else if (!this.transformerModel.transformer.contentTypes.output) {
        return this.$i18n_t('Connectors.Transformer.testButtonTooltip.outputTypeRequired');
      } else if (!this.transformTestInput) {
        return this.$i18n_t('Connectors.Transformer.testButtonTooltip.examplePayloadRequired');
      }

      return undefined;
    }
  }),
  watch: {
    '$route.params.id': {
      handler: function handler(id) {
        this.loadTransformer(id);
      },
      deep: true,
      immediate: false
    },
    'transformerModel.transformer.type': {
      handler: function handler() {
        if (this.transformerModel.id) {
          return;
        }

        if (get(this.transformerModel, 'transformer.type') === 'jsonata') {
          this.transformerModel.transformer.definition = '$';
        } else if (get(this.transformerModel, 'transformer.type') === 'javascript') {
          this.transformerModel.transformer.definition = 'return x;';
        }
      }
    }
  },
  created: function created() {
    if (this.viewMode === VIEW_MODES.CREATE) {
      this.showMetaSkeleton = false;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.fetchAccounts().then(function () {
      if (_this2.viewMode === VIEW_MODES.EDIT) {
        _this2.loadTransformer(_this2.$route.params.id);
      }
    }).catch(function (error) {
      console.error(error);
    });
  },
  methods: {
    loadTransformer: function loadTransformer(id) {
      var _this3 = this;

      ApiService.consumerTransformersGet(id).then(function (response) {
        _this3.transformerModel = response;
        _this3.selectedAccount = _this3.accounts.find(function (item) {
          return item.id === _this3.transformerModel.tenantId;
        });
        _this3.showMetaSkeleton = false;
      }).catch(function (error) {
        // clear transformer and selected account
        _this3.transformerModel = cloneDeep(emptyTransformer);
        _this3.selectedAccount = {};

        _this3.$snack(error.data.original.message, 'error');
      });
    },
    onCmFocus: function onCmFocus(ref) {
      this.refreshForm(ref);
      this.cmLineNumbers = true;
    },
    refreshForm: function refreshForm() {
      var _this4 = this;

      var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'codemirror';
      setTimeout(function () {
        if (_this4.$refs[ref]) {
          // required workaround to get the cursor appearing at the right spot
          // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
          _this4.$refs[ref].codemirror.refresh();

          _this4.$refs[ref].codemirror.focus();
        }
      }, 50);
    },
    fetchAccounts: function fetchAccounts() {
      var _this5 = this;

      return this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this5.accounts = accounts; // if only one account is available, auto select it

        if (_this5.accounts.length === 1) {
          _this5.selectedAccount = _this5.accounts[0];
        }
      }).catch(function (error) {
        console.error(error);

        _this5.$snack(_this5.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    },
    updateTransformer: function updateTransformer() {
      var _this6 = this;

      var promise = null;

      if (this.transformerModel.id) {
        promise = ApiService.consumerTransformersUpdate(this.transformerModel.id, this.transformerModel);
      } else {
        promise = ApiService.consumerTransformersCreate(this.selectedAccount.id, this.transformerModel);
      }

      promise.then(function () {
        _this6.$router.push('/connectors/consumers/transformers');
      }).catch(function (error) {
        _this6.$snack(error.response.data.message, 'error');
      });
    },
    testTransformer: function testTransformer() {
      var _this7 = this;

      var value = this.transformTestInput;

      try {
        var parsedValue = JSON.parse(this.transformTestInput);

        if (_typeof(parsedValue) === 'object') {
          value = parsedValue;
        }
      } catch (e) {
        this.transformTestOutput = '';
        return this.$snack(e.message, 'warning');
      }

      return ApiService.consumerTransformersTest({
        value: value,
        transformer: cloneDeep(this.transformerModel.transformer),
        tenantId: this.selectedAccount.id
      }).then(function (res) {
        if (res.error) {
          var message;

          if (isArray(res.error.data)) {
            message = get(res, 'error.data[0].message', 'error');
          } else {
            message = get(res, 'error.data.original.message', 'error');
          }

          var type = _this7.$i18n_t('Error')[res.error.type];

          _this7.$snack("".concat(type, ": ").concat(message), 'error');
        } else {
          _this7.transformTestOutput = JSON.stringify(res, null, 2);
        }
      }).catch(function (e) {
        _this7.transformTestOutput = '';

        _this7.$snack(e.message, 'error');
      });
    }
  }
};